import React from 'react';
import CgmAppSidebar from './CgmAppSidebar';
import './CgmAppLayout.css';

export default function CgmAppLayout({ children }) {
  return (
    <div className="cgm-app-shell">
      <CgmAppSidebar />
      <div className="cgm-app-shell__main">{children}</div>
    </div>
  );
}
